import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import custom from "./util/custom";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import "./assets/css/reset.css";
import "lib-flexible";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import scroll from "vue-seamless-scroll";
// import jkMap from "jk-map";
import VueAnimateNumber from "vue-animate-number";
import VueLazyload from "vue-lazyload";
import "videojs-contrib-hls";
// import permission from "./components/permission";
Vue.use(VueAnimateNumber);
Vue.use(scroll);
// Vue.use(jkMap.vue);
Vue.use(VueLazyload);
Object.keys(custom).forEach(key => {
  Vue.prototype["$" + key] = custom[key];
});
// Vue.use(permission);
// 百度地图
import BaiduMap from "vue-baidu-map";
import { BmMarker } from "vue-baidu-map";
import { BmGeolocation } from "vue-baidu-map";
import { BmMapType } from "vue-baidu-map";

Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: "pg8IqHGLaSbPpznz8EdDqEi9KXqbxC3P"
});

Vue.component("bm-marker", BmMarker);
Vue.component("bm-geolocation", BmGeolocation);
Vue.component("bm-map-type", BmMapType);
localStorage.setItem("baseapi", window.__config.VUE_APP_IMG_URL);
const requireComponent = require.context(
  // 其组件目录的相对路径
  "./views/components",
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /\.vue$/
);
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);

  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );
  Vue.component(componentName, componentConfig.default || componentConfig);
});

router.beforeEach((to, from, next) => {
  // console.log(
  //   to.name,
  //   "---topathpath--",
  //   from,
  //   "---state---",
  //   store.state.drawer.fromPath
  // );
  if (
    to.name == "newIndex" ||
    from.name === "newIndex" ||
    store.state.drawer.fromPath == "newIndex"
  ) {
    store.dispatch("drawer/setFromPath", "newIndex");
    store.dispatch("schj/setCode", "cg");
  } else {
    store.dispatch("drawer/setFromPath", "home");
    store.dispatch("schj/setCode", "zb");
  }
  // 导航选中处理
  let index = ["granaryIndex", "zzy", "xmy", "yy", "nc"].indexOf(to.name);
  if (index > -1) {
    store.dispatch("map/setGranaryIndex", index);
  }
  // 是否显示地图
  let hasmap = store.state.map.hasmap;
  let nomaplist = [""];
  if (nomaplist.includes(to.path) && hasmap) {
    store.dispatch("map/setHasmap", false);
    //   store.dispatch("map/setMapComponent", null); // 清除地图相关数据
    window.map = null;
  } else if (!nomaplist.includes(to.path) && !hasmap) {
    store.dispatch("map/setHasmap", true);
  }
  next();
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
